import { createAsyncThunk } from '@reduxjs/toolkit';
import { LaunchpadAPI } from '@tacans/shared-marketplace-layer';

export const fetchLaunchpadThunk = createAsyncThunk('launchpad/fetch', async (id: string) => {
    const response = await LaunchpadAPI.fetchById(id);

    return response;
});